import React from 'react'
import { connect } from 'react-redux'
import { formValues } from 'redux-form'
import { IStore } from '../../../../reducers'
import { getCustomColors } from '../../../../reducers/bookingCalendar/selectors/getCustomColors'
import { ColorInput } from '../../../../components/FormBuilder'

const ColorInputWithColors = ({ colors, enabled,disabled,enableSideButton,disableExpandButton, ...rest }: any) => (
  <ColorInput.ReduxField
    colors={colors}
    enabled={enabled}
    disabled={disabled}
    key={enabled}
    withCheckbox={true}
    withPopoverIcon={disabled}
    disableExpandButton={disableExpandButton}
    {...rest}
  />
)

export default connect((state: IStore) => ({
  colors: getCustomColors(state),
}))(formValues<any>({ enabled: 'setCustomColor' })(ColorInputWithColors as any)) as any
